import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import globalSettingsBranches from '../../../../../stores/global-settings-branches';
import { Calendar } from 'primereact/calendar';
import { FilterExpanderWithListOfCheckboxes } from '../../../../../components/CustomExpander/componenets/filter-expander-with-list-of-checkboxes';
import { CustomExpander } from '../../../../../components/CustomExpander/CustomExpander';
import { Button } from 'primereact/button';
import { RealEstateSideBarFiltersType } from './real-estate-side-bar-filters.type';

export interface RealEstateSideBarFilterMetamodel {
  handleSearch: (filter: RealEstateSideBarFiltersType) => any;
}
export const RealEstateSideBarFilter: React.FC<RealEstateSideBarFilterMetamodel> =
  observer(({ handleSearch }) => {
    const [selectedBuildings, setSelectedBuildings] = useState<number[]>([]);
    const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
      null,
      null,
    ]);
    const [timeRange, setTimeRange] = useState<[Date | null, Date | null]>([
      null,
      null,
    ]);

    const handleBuildingToggle = (buildingId: number) => {
      setSelectedBuildings((prev) =>
        prev.includes(buildingId)
          ? prev.filter((id) => id !== buildingId)
          : [...prev, buildingId],
      );
    };

    const styles = {
      container: {
        height: '100%',
        background: 'white',
        borderRadius: '8px',
        padding: '16px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection: 'column' as const,
      },
      header: {
        fontSize: '1.2rem',
        fontWeight: 'bold',
        marginBottom: '16px',
        color: '#333',
      },
      content: {
        flex: 1,
        overflowY: 'auto' as const,
        display: 'flex',
        flexDirection: 'column' as const,
        gap: '8px',
        paddingRight: '4px',
      },
      dateRangeContainer: {
        display: 'flex',
        flexDirection: 'column' as const,
        gap: '8px',
        padding: '8px',
      },
      calendarWrapper: {
        display: 'flex',
        flexDirection: 'column' as const,
        gap: '8px',
      },
      calendarLabel: {
        fontSize: '0.9rem',
        color: '#666',
      },
    };

    const onSearch = async () => {
      const filters: RealEstateSideBarFiltersType = {
        buildingIds: selectedBuildings,
        dateRangeStart: dateRange[0],
        dateRangeEnd: dateRange[1],
        timeRangeStart: timeRange[0],
        timeRangeEnd: timeRange[1],
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
      handleSearch(filters);
    };

    return (
      <div style={styles.container}>
        <div style={styles.header}>סינונים</div>
        <div style={styles.content}>
          <FilterExpanderWithListOfCheckboxes
            title="מבנים"
            items={globalSettingsBranches.buildings}
            selectedItems={selectedBuildings}
            onItemToggle={handleBuildingToggle}
            getItemLabel={(building) => building.buildingName}
            getItemKey={(building) => building.id}
            defaultExpanded={true}
            searchPlaceholder="חפש מבנה..."
          />

          <CustomExpander>
            <div>טווח זמנים</div>
            <div style={styles.dateRangeContainer}>
              <div style={styles.calendarWrapper}>
                <span style={styles.calendarLabel}>מתאריך:</span>
                <Calendar
                  value={dateRange[0]}
                  onChange={(e) =>
                    setDateRange([e.value as Date, dateRange[1]])
                  }
                  dateFormat="dd/mm/yy"
                  showIcon
                  iconPos="right"
                  style={{
                    height: '36px',
                    width: '100%',
                    direction: 'ltr',
                  }}
                  inputStyle={{ direction: 'rtl' }}
                />
              </div>
              <div style={styles.calendarWrapper}>
                <span style={styles.calendarLabel}>עד תאריך:</span>
                <Calendar
                  value={dateRange[1]}
                  onChange={(e) =>
                    setDateRange([dateRange[0], e.value as Date])
                  }
                  dateFormat="dd/mm/yy"
                  showIcon
                  iconPos="right"
                  style={{
                    height: '36px',
                    width: '100%',
                    direction: 'ltr',
                  }}
                  inputStyle={{ direction: 'rtl' }}
                  minDate={dateRange[0] || undefined}
                />
              </div>
            </div>
          </CustomExpander>

          <CustomExpander>
            <div>טווח שעות</div>
            <div style={styles.dateRangeContainer}>
              <div style={styles.calendarWrapper}>
                <span style={styles.calendarLabel}>התחלה:</span>
                <Calendar
                  value={timeRange[0]}
                  onChange={(e) =>
                    setTimeRange([e.value as Date, timeRange[1]])
                  }
                  timeOnly
                  showTime
                  hourFormat="24"
                  showIcon
                  iconPos="right"
                  placeholder="בחר שעת התחלה"
                  style={{
                    height: '36px',
                    width: '100%',
                    direction: 'ltr',
                  }}
                  inputStyle={{ direction: 'rtl', textAlign: 'right' }}
                  panelStyle={{ direction: 'ltr' }}
                  stepMinute={15}
                />
              </div>
              <div style={styles.calendarWrapper}>
                <span style={styles.calendarLabel}>סיום:</span>
                <Calendar
                  value={timeRange[1]}
                  onChange={(e) =>
                    setTimeRange([timeRange[0], e.value as Date])
                  }
                  timeOnly
                  showTime
                  hourFormat="24"
                  showIcon
                  iconPos="right"
                  placeholder="בחר שעת סיום"
                  style={{
                    height: '36px',
                    width: '100%',
                    direction: 'ltr',
                  }}
                  inputStyle={{ direction: 'rtl', textAlign: 'right' }}
                  panelStyle={{ direction: 'ltr' }}
                  stepMinute={15}
                  minDate={timeRange[0] || undefined}
                />
              </div>
            </div>
          </CustomExpander>
        </div>

        <div
          style={{
            marginTop: '16px',
            padding: '8px',
            borderTop: '1px solid #e9ecef',
          }}
        >
          <Button
            label="חפש"
            icon="pi pi-search"
            style={{
              width: '100%',
              backgroundColor: '#2196F3',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              padding: '12px',
              fontSize: '1rem',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
            }}
            onClick={onSearch}
          />
        </div>
      </div>
    );
  });
